import { render, staticRenderFns } from "./travel-list.vue?vue&type=template&id=1bfa53c4&"
import script from "./travel-list.vue?vue&type=script&lang=js&"
export * from "./travel-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports